import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Image } from 'react-native';

export interface ScaledImageProps {
  uri: string;
  width?: number;
  height?: number;
}
export const ScaledImage: React.FC<ScaledImageProps> = (props) => {
  const [dimensionImage, setDimensionImage] = useState({ width: 0, height: 0 });
  const [realSizeImage, setRealSizeImage] = useState({ width: 0, height: 0 });
  const { uri, width: widthInput, height: heightInput } = props;

  useEffect(() => {
    if (widthInput && !heightInput) {
      setDimensionImage({
        width: widthInput,
        height: realSizeImage.height * (widthInput / realSizeImage.width)
      });
    } else if (!widthInput && heightInput) {
      setDimensionImage({
        width: realSizeImage.width * (heightInput / realSizeImage.height),
        height: heightInput
      });
    } else {
      setDimensionImage({ width: realSizeImage.width, height: realSizeImage.height });
    }
  }, [realSizeImage, widthInput, heightInput]);

  useEffect(() => {
    Image.getSize(uri, (width, height) => {
      setRealSizeImage({ width, height });
    });
  }, [uri]);
  if (_.isNaN(dimensionImage.height) || _.isNaN(dimensionImage.width)) return <></>;
  return <Image source={{ uri }} style={{ height: dimensionImage.height, width: dimensionImage.width as number }} />;
};
